import React, { Component } from "react";

class Gamedev extends Component {
    render() {
        return (
            <div className="centercontent footermargin">
                <h1>Game Development</h1>

                <div className="descarea">
                    <div className="descbox">
                        <p>
                            I learned to program using Unity and C# in vocational college. I have always loved video games and so
                            game development was something that I wanted to do. Here are some sneak peeks into the projects I've done.
                        </p>
                    </div>

                    <img id="img" src="..\imgs\avatar_yellow_portrait_small.jpg" alt="avatar icon"/>
                </div>

                <div className="tape projecttape" style={{backgroundImage: "url('../imgs/concepts/ocean_blur.jpg')", backgroundPositionY: "-250px", backgroundSize: "cover"}}>
                    <div className="page">
                        <h2><span>WIP Planet Game</span></h2>
                        <h4>
                            Project "Planet Game" is a sandbox action-adventure game set in a sci-fi solar system, where the player explores
                            various planets and dangerous environments, discovers alien structures and technology, while improving their
                            gear and loadout to fight increasingly challenging enemies and bosses. The game takes inspiration from Terraria and Starbound.
                            <br></br><br></br>
                            I'm using <span>Unity</span> to build the game. I'm working with international friends who help me with game design, testing, and
                            graphics. This project has the most potential out of all the projects I've started so far. Me and my co-developer are
                            ready to make this into a marketable product if early demos prove it worthy.
                        </h4>
                    </div>
                </div>

                <h2>Concept Art and Early Demos</h2>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/day.jpg" alt="concept art"></img>
                    </div>

                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/first.jpg" alt="concept art"></img>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/rogue.jpg" alt="concept art"></img>
                    </div>

                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/ui_new_crop.jpg" alt="concept art"></img>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/dark.jpg" alt="concept art"></img>
                    </div>

                    <div className="tapeexhibit">
                        <img src="../imgs/concepts/space.jpg" alt="concept art"></img>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/planetgame_combat_comp.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/planetgame_terraforming_comp.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>

                <div className="tape projecttape" style={{backgroundImage: "url('../imgs/projects/shootaman_bg_blur.jpg')", backgroundPositionY: "-150px", backgroundSize: "cover"}}>
                    <div className="page">
                        <h2><span>Shootaman</span></h2>
                        <h4>
                            I wanted to make a first person shooter game to learn 3D modelling, animating and
                            a bit of level design. The project turned into a bloody action game set in a simple
                            office, where the player gets to shoot baddies and play with an entirely
                            physics based environment.
                            <br></br><br></br>
                            As usual, I made this game with Unity and C#. I did 3D models and animations in Blender.
                            I made a demo of the game that I shared with a small group of friends on Discord.
                            I didn't continue development after the first demo, though the game could have done with
                            music and SFX, bug fixes and a little more content.
                        </h4>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/shootaman_action_early.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/shootaman_demo_comp.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>

                <div className="tape projecttape" style={{backgroundImage: "url('../imgs/projects/notskyrim_bg_blur.jpg')", backgroundPositionY: "-150px", backgroundSize: "cover"}}>
                    <div className="page">
                        <h2><span>NotSkyrim</span></h2>
                        <h4>
                            This is a project I started with a friend who wanted to learn more world building.
                            The game was supposed to be a medieval open world action-adventure game with RPG elements.
                            A lot of inspiration was taken from games like Skyrim and Witcher. I implemented many basic
                            systems, like a simple inventory and combat, including melee and magic attacks.
                            <br></br><br></br>
                            Although we had some systems completed and many more ideas planned, the game was discontinued
                            after our collective interest diminished and other projects sparked more motivation.
                            The project taught me good lessons about project scope and management.
                            <br></br><br></br>
                            Video clips coming at some point...
                        </h4>
                    </div>
                </div>

                <div className="tape projecttape" style={{backgroundImage: "url('../imgs/projects/oldbits_bg_blur.jpg')", backgroundPositionY: "-250px", backgroundSize: "cover"}}>
                    <div className="page">
                        <h2><span>Older Bits</span></h2>
                        <h4>
                            Here are some clips of very old projects of mine. I've done many things, including multiplayer arcade games with custom controllers,
                            a skeleton of a Terraria clone, FPS controllers, simple racing systems, chunk loading systems and custom mesh generation.
                            <br></br><br></br>
                            These are some of the projects I learned game development with. They have taught me valuable lessons on C#, Unity, and
                            several elements of game development like project planning, team work, iterative problem solving, and essential game design.
                        </h4>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://i.imgur.com/YiuBgV5.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://i.imgur.com/IOw64Hz.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://i.imgur.com/fWNbG9r.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://i.imgur.com/kRoRjUt.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://cdn.discordapp.com/attachments/774162660936646658/907997922577223690/Ihsa1osPq9.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="https://cdn.discordapp.com/attachments/774162660936646658/902296237754183710/qyqP81HBWa.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>
            </div>
        );
    }
}

export default Gamedev;